import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { L10N_LOCALE, L10nLocale, L10nTranslatePipe } from 'angular-l10n';

export type MfaReminderResult = 'later' | 'setup';

@Component({
  selector: 'app-mfa-reminder-dialog',
  templateUrl: './mfa-reminder-dialog.component.html',
  styleUrls: ['./mfa-reminder-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, MatIconModule, L10nTranslatePipe],
})
export class MfaReminderDialogComponent {
  readonly locale = inject<L10nLocale>(L10N_LOCALE);
  private readonly dialogRef = inject(MatDialogRef<MfaReminderDialogComponent>);

  remindLater(): void {
    this.dialogRef.close('later' satisfies MfaReminderResult);
  }

  setupNow(): void {
    this.dialogRef.close('setup' satisfies MfaReminderResult);
  }
}
